import { useMemo } from 'react';

import { useSjActions } from '@/shared/lib/sj-orm/hooks/useSjActions';
import { BeneficiaryPersonalDataDocumentDto } from '@/shared/lib/sj-orm/models/document/beneficiary-personal-data.document.dto';
import { useKeyPairStore } from '@/shared/store/decrypted-keypair.store';

export type BeneficiaryPidCreateData = Omit<BeneficiaryPersonalDataDocumentDto, 'id'>;

export const useBeneficiariesPidActions = () => {
  const keyPair = useKeyPairStore((s) => s.keyPair);
  const { create: beneficiariesPidCreate, ...actionsRest } = useSjActions(
    'beneficiaryPersonalDataDocuments',
  );

  return useMemo(() => {
    const create = async (
      data: BeneficiaryPidCreateData,
    ): Promise<BeneficiaryPersonalDataDocumentDto | null> => {
      if (!keyPair?.publicKey) {
        return null;
      }

      const dto: BeneficiaryPersonalDataDocumentDto = {
        id: actionsRest.generateId(),
        ...data,
      };

      await beneficiariesPidCreate(dto, [keyPair.publicKey]);

      return dto;
    };

    return { create, ...actionsRest };
  }, [keyPair]);
};
